import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AsyncValidatorsService } from '@shared/services/async-validators.service';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { BadResponseWithError } from '../../models/common.interface';
import { AsyncValidatorsActions } from '../action/actions-type.action';

@Injectable({ providedIn: 'root' })
export class AsyncValidatorsEffect {
    validateUsername$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AsyncValidatorsActions.validateUsername),
            exhaustMap(({ payload }) =>
                this.asyncValidatorsService.validateUsername(payload).pipe(
                    map(() => AsyncValidatorsActions.validateUsernameSuccess()),
                    catchError((response: BadResponseWithError) => {
                        return of(
                            AsyncValidatorsActions.validateUsernameFailure({
                                payload: response,
                            })
                        );
                    })
                )
            )
        )
    );

    validateEmail$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AsyncValidatorsActions.validateEmail),
            exhaustMap(({ payload }) =>
                this.asyncValidatorsService.validateEmail(payload).pipe(
                    map(() => AsyncValidatorsActions.validateEmailSuccess()),
                    catchError((response: BadResponseWithError) => {
                        return of(
                            AsyncValidatorsActions.validateEmailFailure({
                                payload: response,
                            })
                        );
                    })
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private asyncValidatorsService: AsyncValidatorsService
    ) {}
}
